import { put } from 'redux-saga/effects'
import axios from '../../axios-conf'
import uris from '../../uris'
import {
  campaignLoadSuccess,
  campaignLoadFailure,
  campaignSaveSuccess,
  campaignSaveFailure,
  redirect,
  addNotification,
  campaignDeleteFailure,
  campaignDeleteSuccess,
  campaignBackToDraftSuccess,
  campaignBackToDraftFailure
} from '../actions'
import { uiConstants } from '../../constants'
import { uiHelper } from '../../helpers'

export function* campaignLoadSaga() {
  try {
    const result = yield axios.get(uris.campaign)
    yield put(campaignLoadSuccess(result.data))
  } catch (error) {
    yield put(campaignLoadFailure(error))
  }
}

export function* campaignSaveSaga(action) {
  try {
    const body = { ...action.payload }
    let url = uris.campaign
    let method = 'post'
    if (action.payload.id) {
      url += `/${action.payload.id}`
      method = 'put'
    }
    delete body.id
    const result = yield axios({
      method,
      url,
      data: body
    })
    yield put(campaignSaveSuccess(result.data))

    if (!action.payload.id) {
      const [, id] = uiHelper.location()
      yield put(redirect(`/${id}/campaigns/${result.data._id}`))
    }
    yield put(
      addNotification(
        action.payload.id
          ? uiConstants.messages.campaign_updated
          : uiConstants.messages.campaign_created
      )
    )
  } catch (error) {
    yield put(addNotification(uiHelper.errorMessage(error), true))
    yield put(campaignSaveFailure(uiHelper.errorMessage(error)))
  }
}

export function* campaignDeleteSaga(action) {
  try {
    yield axios.delete(`${uris.campaign}/${action.payload}`)
    const [, id] = uiHelper.location()
    yield put(redirect(`/${id}/campaigns`))
    yield put(campaignDeleteSuccess(action.payload))
    yield put(addNotification(uiConstants.messages.campaign_deleted))
  } catch (error) {
    yield put(addNotification(uiHelper.errorMessage(error), true))
    yield put(campaignDeleteFailure(uiHelper.errorMessage(error)))
  }
}

export function* campaignBackToDraftSaga(action) {
  try {
    const result = yield axios.patch(`${uris.campaign}/${action.payload}/draft`)
    yield put(campaignBackToDraftSuccess(result.data))
    yield put(addNotification(uiConstants.messages.campaign_back_to_draft))
  } catch (error) {
    yield put(addNotification(uiHelper.errorMessage(error), true))
    yield put(campaignBackToDraftFailure(uiHelper.errorMessage(error)))
  }
}
